<template>
    <div>
        <div
            class="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700 my-4 hidden"
        >
            <div
                class="bg-red h-2.5 rounded-full"
                :style="{ width: progressPercentage + '%' }"
            ></div>
        </div>

        <div v-if="step === 1">
            <strong class="text-red font-bold">
                Informations personnelles</strong
            >
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label>Nom</label>
                    <input
                        type="text"
                        v-model="form.lastname"
                        :class="{
                            inputIsInvalid: apiStore.$state.errors.lastname,
                        }"
                    />
                </div>
                <div>
                    <label>Prénom</label>
                    <input
                        type="text"
                        v-model="form.firstname"
                        :class="{
                            inputIsInvalid: apiStore.$state.errors.firstname,
                        }"
                    />
                </div>
                <div>
                    <label>Email</label>
                    <input
                        type="email"
                        v-model="form.email"
                        :class="{
                            inputIsInvalid: apiStore.$state.errors.email,
                        }"
                    />
                </div>
                <div>
                    <label>Numéro</label>
                    <input
                        type="tel"
                        v-model="form.phone"
                        :class="{
                            inputIsInvalid: apiStore.$state.errors.phone,
                        }"
                    />
                </div>

                <!--
                <div>
                    <label>Date de naissance</label>
                    <input type="date" v-model="form.birthdate" />
                </div>
                <div>
                    <label>Etat civil</label>
                    <select v-model="form.civilStatus">
                        <option value="single">Célibataire</option>
                        <option value="married">Marié</option>
                        <option value="divorced">Divorcé</option>
                    </select>
                </div>
                <div>
                    <label>Numéro national</label>
                    <input type="text" v-model="form.nationalNumber" />
                </div>
                -->
            </div>
        </div>

        <!--


        <div v-if="step === 2">
            <strong class="text-red font-bold"
                >Informations professionnelles</strong
            >
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label>Catégorie professionnelle</label>
                    <select v-model="form.professionCategory">
                        <option value="employee">Employé</option>
                        <option value="worker">Ouvrier</option>
                        <option value="independent">Indépendant</option>
                        <option value="retired">Pensionné</option>
                        <option value="student">Etudiant</option>
                        <option value="unemployed">Sans emploi</option>
                    </select>
                </div>
                <div>
                    <label>Profession ou activité précise</label>
                    <input type="text" v-model="form.profession" />
                </div>
                <div>
                    <label>Type de contrat</label>
                    <select v-model="form.contractType">
                        <option value="cdi">CDI</option>
                        <option value="cdd">CDD</option>
                        <option value="interim">Intérim</option>
                        <option value="independent">Indépendant</option>
                        <option value="student">Etudiant</option>
                        <option value="unemployed">Sans emploi</option>
                    </select>
                </div>
                <div
                    v-if="
                        form.contractType === 'cdi' ||
                        form.contractType === 'cdd'
                    "
                >
                    <label>Chez l'employeur depuis</label>
                    <input type="date" v-model="form.contractDate" />
                </div>
                <div
                    v-if="
                        form.contractType === 'cdi' ||
                        form.contractType === 'cdd'
                    "
                >
                    <label>Nom de l'employeur</label>
                    <input type="text" v-model="form.employerName" />
                </div>
                <div
                    v-if="
                        form.contractType === 'cdi' ||
                        form.contractType === 'cdd'
                    "
                >
                    <label>Adresse de l'employeur</label>
                    <input type="text" v-model="form.employerAddress" />
                </div>
                <div>
                    <label>Revenu net mensuel</label>
                    <div class="flex">
                        <input type="number" v-model="form.monthlyIncome" />
                        <span class="mt-2 w-2/5 ml-2 font-bold">€/mois</span>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="step === 3">
            <strong class="text-red font-bold">Domicile</strong>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label>Adresse</label>
                    <input type="text" v-model="form.address" />
                </div>
                <div>
                    <label>A cette adrese depuis</label>
                    <input type="date" v-model="form.addressDate" />
                </div>
                <div>
                    <label>Je suis...</label>
                    <select v-model="form.homeType">
                        <option value="locataire">Locataire</option>
                        <option value="proprietaire">Propriétaire</option>
                    </select>
                </div>
                <div v-if="form.homeType === 'locataire'">
                    <label>Montant du loyer</label>
                    <div class="flex">
                        <input type="number" v-model="form.monthlyRent" />
                        <span class="mt-2 w-2/5 ml-2 font-bold">€/mois</span>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="step === 4">
            <strong class="text-red font-bold"
                >Liste des crédits en cours</strong
            >
            <div
                v-for="(credit, index) in form.credits"
                :key="index"
                class="grid grid-cols-1 lg:grid-cols-6 border-2 rounded-lg p-2 gap-4 mt-2 mb-2 lg:border-none"
            >
                <div class="lg:col-span-3">
                    <label>Type de charge</label>
                    <select v-model="credit.type">
                        <option value="mortgage">Hypothécaire</option>
                        <option value="personal">Personnel</option>
                        <option value="car">Auto</option>
                        <option value="other">Autre</option>
                    </select>
                </div>
                <div class="lg:col-span-2">
                    <label>Montant</label>
                    <div class="flex">
                        <input type="number" v-model="credit.amount" /><span
                            class="mt-2 w-2/5 ml-2 font-bold"
                            >€/mois</span
                        >
                    </div>
                </div>
                <div class="text-center w-full self-center col-span-1">
                    <primary-button
                        @click="removeCredit(index)"
                        v-if="form.credits.length > 1"
                        danger
                    >
                        -
                    </primary-button>
                </div>
            </div>
            <div class="text-center w-full">
                <primary-button @click="addCredit" color="red">
                    +
                </primary-button>
            </div>
        </div>

        -->

        <div class="flex justify-between mt-4">
            <button
                @click="prevStep"
                v-if="step > 1"
                class="bg-gray-500 text-white px-4 py-2 rounded"
            >
                Précédent
            </button>
            <div v-else></div>
            <button
                @click="nextStep"
                v-if="step < 1"
                class="bg-red text-white px-4 py-2 rounded"
            >
                Suivant
            </button>
            <button
                @click="submitForm"
                v-if="step === 1"
                class="bg-red text-white px-4 py-2 rounded"
            >
                Soumettre
            </button>
        </div>
    </div>
</template>

<script setup>
import { useApiStore } from '@/js/stores/apiStore';
import { computed, reactive, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const $router = useRouter();

const route = useRoute();
const apiStore = useApiStore();

const step = ref(1);

const form = reactive({
    name: '',
    firstname: '',
    birthdate: '',
    address: '',
    civilStatus: 'single',
    professionCategory: 'employee',
    profession: '',
    contractType: 'cdi',
    credits: [{ type: '', amount: '' }],
    message:
        'Client intéressé par une offre de leasing B2C pour le vélo id :' +
        route.params.id,
});

/*
const addCredit = () => {
    form.credits.push({ type: '', amount: '' });
};

const removeCredit = index => {
    form.credits.splice(index, 1);
};
*/

const nextStep = () => {
    if (step.value < 4) step.value++;
};

const prevStep = () => {
    if (step.value > 1) step.value--;
};

const submitForm = () => {
    apiStore
        .apiPost('/api/emails/contact', form)
        .then(() => {
            $router.push({
                name: 'thank-you-for-the-leasing-request',
            });
        })
        .catch(() => {});
};

const progressPercentage = computed(() => {
    return (step.value / 4) * 100;
});
</script>
